export const CONSTANTS = {
  ALL_AUTHORS_TITLE: "All Authors",
  ADD_NEW_AUTHOR_BUTTON: "Add Author",
  SEARCH_AUTHORS_LABEL: "Search Author",
  ACCEPTED_IMAGE_TYPES: ["image/jpeg", "image/png", "image/gif"],
  DELETE_CONFIRM_TITLE: "Confirm Delete",
  DELETE_CONFIRM_MESSAGE: "Are you sure you want to delete this item?",
  CANCEL_BUTTON: "Cancel",
  ADD_BUTTON: "Add",
  THROTTLE_DURATION: 3000,
};
